export const VIDEO_SERVER_REQ_ENDPOINT = `https://www.myfreecams.com/modeldirector`
export const BROADCASTER_WRAPPER_ID = 'broadcaster-wrapper'
export const BROADCASTER_CONTAINER_ID = 'broadcaster-container'

export const CLASS_BROADCASTER_CONTAINER_OVERRIDE =
    'broadcaster-container-override'
export const CLASS_BROADCASTER_SETTINGS_VISIBLE =
    'broadcaster-publisher-settings-visible'

export enum BROADCASTING_STATE {
    ERROR = 'ERROR',
    UNINITIALIZED = 'UNINITIALIZED',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    OFF = 'OFF',
    ON = 'ON',
}
